<template>
  <DataComboBox
    :value="value"
    @input="$emit('input', $event)"
    :config="config"
  />
</template>

<script>
import DataComboBox from "../controls/DataComboBox.vue";

export default {
  name: "ConnectionPicker",

  components: { DataComboBox },

  props: ["value", "title"],

  data() {
    return {
      config: {
        title: this.title,
        listDataSource: "dataconnections/list",
        listTextField: "name",
        listValueField: "connectionId",
      },
    };
  },
};
</script>
